import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useActivity, ACTIVITY_TYPES, RESOURCE_TYPES } from '../contexts/ActivityTrackingContext';

const NavigationTracker = () => {
  const location = useLocation();
  const { userInfo } = useContext(AuthContext);
  const { trackActivity } = useActivity();
  
  useEffect(() => {
    if (location.pathname === '/login' && !location.key) {
      return;
    }
    
    const exactPath = location.pathname;
    
    const getPageName = () => {
      return `Page: ${exactPath}`;
    };
    
    trackActivity(
      ACTIVITY_TYPES.VIEW,
      RESOURCE_TYPES.USER,
      userInfo?.data?._id,
      getPageName(),
      {
        exact_path: exactPath,
        full_url: window.location.href,
        search_params: location.search,
        referrer: document.referrer || 'direct',
        userAgent: navigator.userAgent
      }
    );
  }, [location.pathname, location.search, trackActivity, userInfo]);
  
  return null;
};

export default NavigationTracker;